import {defHttp} from '/@/utils/http/axios';

enum Api {
  getSceneParam = '/icl-engine/getSceneParam',
  execute = '/icl-engine/execute'
}

export const getSceneParams = (sceneCode) => {
  return defHttp.get({ url: `${Api.getSceneParam}?sceneCode=${sceneCode}`}, { errorMessageMode: 'none', successMessageMode: 'none' });
}

export const execSceneRule = (sceneCode, params) => {
  return defHttp.post({ url: Api.execute, params: { sceneCode, params }}, { errorMessageMode: 'none', successMessageMode: 'none' })
}